import BarcodePrint from './BarcodePrint';

export default BarcodePrint;
